import React, { useState, ReactElement, useEffect } from "react";
import Header from "@/components/Header";
import { useIsMobile } from "@/hooks/use-mobile";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
interface PartsLayoutProps {
  children: React.ReactNode;
  viewMode: "grid" | "table";
  setViewMode: (mode: "grid" | "table") => void;
  sidebar: React.ReactNode;
  sidebarExpanded: boolean;
  toggleSidebar: () => void;
}

// Define interface for components that can receive sidebarExpanded prop
interface WithSidebarExpandedProps {
  sidebarExpanded?: boolean;
}
const PartsLayout: React.FC<PartsLayoutProps> = ({
  children,
  viewMode,
  setViewMode,
  sidebar,
  sidebarExpanded,
  toggleSidebar
}) => {
  const isMobile = useIsMobile();

  // Only pass sidebarExpanded to children that expect it
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      // Check if the child component accepts the sidebarExpanded prop
      const childType = child.type as any;
      if (childType && childType.propTypes && 'sidebarExpanded' in childType.propTypes) {
        return React.cloneElement(child, {
          sidebarExpanded
        } as WithSidebarExpandedProps);
      }
      return child;
    }
    return child;
  });

  // Track sidebar visibility on mobile
  const [mobileOpen, setMobileOpen] = useState(false);

  // Update toggleSidebar to handle mobile case
  const handleToggleSidebar = () => {
    if (isMobile) {
      console.log("Mobile toggle sidebar, current state:", mobileOpen);
      setMobileOpen(!mobileOpen);
    } else {
      console.log("Desktop toggle sidebar, current state:", sidebarExpanded);
      toggleSidebar();
    }
  };
  console.log("PartsLayout rendering with sidebarExpanded:", sidebarExpanded);
  return <div className="min-h-screen flex flex-col bg-background relative w-full">
      <Header viewMode={viewMode} setViewMode={setViewMode} pageName="Parts" sidebarExpanded={sidebarExpanded} toggleSidebar={handleToggleSidebar} />
      
      <div className="flex flex-1 w-full">
        {/* Desktop sidebar */}
        {!isMobile && <div className={`h-full transition-all duration-300 ${sidebarExpanded ? 'w-64' : 'w-0 overflow-hidden'}`} style={{
        position: 'relative',
        zIndex: 10
      }}>
            {sidebar}
          </div>}
        
        {/* Mobile sidebar uses Drawer */}
        {isMobile && <Drawer open={mobileOpen} onOpenChange={setMobileOpen}>
            <DrawerContent className="h-[85vh] max-h-[85vh] overflow-y-auto">
              {sidebar}
            </DrawerContent>
          </Drawer>}
        
        <div className="flex-1 w-full">
          <main className="container py-2 w-full max-w-full px-4">
            {childrenWithProps}
          </main>
        </div>
      </div>
      
      
    </div>;
};
export default PartsLayout;